import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { WHATSAPP_LINK } from '../constants';

const Navbar = () => {
  const navClass = ({ isActive }) => `nav-item nav-link ${isActive ? 'active' : ''}`;

  // Função para rolar a página para o topo e fechar o menu mobile
  const handleNavClick = () => {
    // Rola a página suavemente para o topo
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    // Fecha o menu colapsável em telas menores (se estiver aberto)
    const navbarCollapse = document.getElementById('navbarCollapse');
    if (navbarCollapse && navbarCollapse.classList.contains('show')) {
      // Usando a API do Bootstrap para fechar o collapse de forma segura
      const bsCollapse = window.bootstrap?.Collapse.getInstance(navbarCollapse);
      if (bsCollapse) {
        bsCollapse.hide();
      } else {
        // Fallback caso a instância do Bootstrap não seja encontrada
        navbarCollapse.classList.remove('show');
      }
    }
  };

  return (
    <div className="container-fluid bg-white sticky-top wow fadeIn" data-wow-delay="0.1s">
      <div className="container">
        <nav className="navbar navbar-expand-lg bg-white navbar-light p-lg-0">
          <Link to="/" className="navbar-brand d-flex align-items-center gap-3 py-3" onClick={handleNavClick}>
            <div className="brand-badge">M</div>
            <div>
              <span className="brand-title">Mafra Tintas</span>
              <small className="brand-subtitle">Qualidade em cada detalhe</small>
            </div>
          </Link>
          <button
            type="button"
            className="navbar-toggler me-0"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
            aria-label="Abrir menu"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <div className="navbar-nav mx-auto">
              <NavLink to="/" className={navClass} onClick={handleNavClick}>Início</NavLink>
              <NavLink to="/about" className={navClass} onClick={handleNavClick}>Sobre</NavLink>
              <NavLink to="/produtos" className={navClass} onClick={handleNavClick}>Produtos</NavLink>
              <NavLink to="/contact" className={navClass} onClick={handleNavClick}>Contatos</NavLink>
            </div>
            <div className="ms-auto d-none d-lg-block">
              <a
                href={WHATSAPP_LINK}
                className="btn btn-primary py-2 px-3"
                target="_blank"
                rel="noreferrer"
              >
                Fale Conosco
              </a>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;